import Keerthana from "../assets/Keerthana.jpeg"
import Kesavprasad from "../assets/Kesavprasad.jpeg"
import Harsha from "../assets/harsha_s_brakes.jpeg"
import Mutukumar from "../assets/Mutukumar.jpeg"
import Lekha from "../assets/Lekha.jpeg"
import Atola from "../assets/Atola.jpeg"
import Sasi from "../assets/Sasi.jpeg"
import Rohan from "../assets/Rohan.jpeg"
import Aditya from "../assets/Aditya.jpeg"
import Venkatesh from "../assets/Venkatesh.jpg"
import Akilesh from "../assets/Akilesh.jpeg"
import Piyush from "../assets/Piyush.jpeg"
import Balaji from "../assets/Balaji.jpeg"
import Ravish from "../assets/Ravish.jpeg"
import Sripaad from "../assets/Sripaad.jpeg"
import Vismay from "../assets/Vismay.jpeg"
import Vyshnav from "../assets/Vyshnav.jpeg"
import Harish from "../assets/Harish.jpeg"
import Manasa from "../assets/Manasa.jpeg"
import Kabilan from "../assets/Kabilan.jpg"
import Nikhil from "../assets/Nikhil.jpeg"
import Shiva from "../assets/Shiva.jpeg"
import Vijay from "../assets/Vijay.jpeg"
import Girim from "../assets/Girim.jpeg"
import Hariram from "../assets/Hariram.jpeg"
import Pravin from "../assets/Pravin.jpeg"
import Suma from "../assets/Suma.jpeg"
import Sreevasth from "../assets/Sreevasth.jpeg"
import Sakshi from "../assets/Sakshi.jpeg"
import Anurag from "../assets/Anurag.jpeg"
import Irfan from "../assets/Irfan.jpeg"
import JK from "../assets/JK.jpeg"
import Karim from "../assets/Karim.jpeg"
import Veni from "../assets/Veni.jpeg"
import Sundar from "../assets/Sundar.jpeg"
import Snekan from "../assets/Snekan.jpeg"
import RV from "../assets/RV.jpeg"
import Narendran from "../assets/Narendran.jpeg"
import Anirudh from "../assets/Anirudh.jpeg"
import Jayaseelan from "../assets/Jayaseelan.jpeg"
import Narendra from "../assets/Narendran.jpeg"
import Manoji from "../assets/Manoji.jpeg"
import Bharan from "../assets/Bharan.jpeg"
import Pavan from "../assets/Pavan.jpeg"
import Anjan from "../assets/Anjan.jpeg"



const teamMembers = [
  { 
    name: 'Sripaad Mahankali',
    role: 'Mentor',
    team: 'Mentors',
    image: Sripaad,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Vismay Chand',
    role: 'Mentor',
    team: 'Mentors',
    image : Vismay,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Vyshnav K',
    role: 'Mentor',
    team: 'Mentors',
    image: Vyshnav,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Piyush Kumar Sinha',
    role: 'Team Captain',
    team: 'HQ',
    image: Piyush,
    linkedin: 'https://www.linkedin.com/in/piyush243kr',
    year: 2023
  },
  { 
    name: 'Akhilesh M',
    role: 'Team Vice Captain',
    team: 'HQ',
    image: Akilesh,
    linkedin: 'https://www.linkedin.com/in/akhilesh-m-6866b1248',
    year: 2023
  },
  { 
    name: 'Ravish Desh Anand',
    role: 'Team Manager',
    team: 'HQ',
    image:Ravish,
    linkedin: 'https://www.linkedin.com/in/ravish-anand-',
    year: 2023
  },
  { 
    name: 'Jana Balaji',
    role: 'Team Joint Manager',
    team: 'HQ',
    image:Balaji,
    linkedin: 'https://www.linkedin.com/in/jana-balaji-818b18228',
    year: 2023
  },
  { 
    name: 'Pavan Kalyan',
    role: 'Team Lead',
    team: 'Team Roll Cage',
    image: Pavan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'J Narendra',
    role: 'Design Engineer',
    team: 'Team Roll Cage',
    image: Narendra,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Suma Asritha Kasetty',
    role: 'Design Engineer',
    team: 'Team Roll Cage',
    image: Suma,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Sreevasths',
    role: 'Design Engineer',
    team: 'Team Roll Cage',
    image: Sreevasth,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Pravin P A',
    role: 'Intern',
    team: 'Team Roll Cage',
    image: Pravin,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Venkatesh S R',
    role: 'Intern',
    team: 'Team Roll Cage',
    image: Venkatesh,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Girimanikandan',
    role: 'Intern',
    team: 'Team Roll Cage',
    image: Girim,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Hariram Selva',
    role: 'Intern',
    team: 'Team Roll Cage',
    image: Hariram,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Anjan Mahapatra',
    role: 'Team Lead',
    team: 'Team Suspension',
    image: Anjan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'G K Aniruddh',
    role: 'Design Engineer',
    team: 'Team Suspension',
    image: Anirudh,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'S Sundar Subramanian',
    role: 'Design Engineer',
    team: 'Team Suspension',
    image: Sundar,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Jayaseelan',
    role: 'Intern',
    team: 'Team Suspension',
    image: Jayaseelan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Narendran V',
    role: 'Intern',
    team: 'Team Suspension',
    image: Narendran,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Venithra S',
    role: 'Intern',
    team: 'Team Suspension',
    image: Veni,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Snekan S',
    role: 'Intern',
    team: 'Team Suspension',
    image: Snekan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'R Venkateswar',
    role: 'Intern',
    team: 'Team Suspension',
    image: RV,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'M Bharanidharan',
    role: 'Team Lead',
    team: 'Team Powertrain',
    image: Bharan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Kabilan S',
    role: 'Design Engineer',
    team: 'Team Powertrain',
    image: Kabilan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Manasa H T',
    role: 'Design Engineer',
    team: 'Team Powertrain',
    image:Manasa,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Vinay Anantharaman',
    role: 'Intern',
    team: 'Team Powertrain',
    image: Vijay,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Harish N',
    role: 'Intern',
    team: 'Team Powertrain',
    image: Harish,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Nikil Narayana M',
    role: 'Intern',
    team: 'Team Powertrain',
    image: Nikhil,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Shiva Kant Pandey',
    role: 'Intern',
    team: 'Team Powertrain',
    image: Shiva,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Ravish Desh Anand',
    role: 'Team Lead',
    team: 'Team DAQ & Electronics',
    image: Ravish,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Jhansi Rajeswari Athota',
    role: 'Design Engineer',
    team: 'Team DAQ & Electronics',
    image: Atola,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Sasi Vadan',
    role: 'Intern',
    team: 'Team DAQ & Electronics',
    image: Sasi,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Aditya K B',
    role: 'Intern',
    team: 'Team DAQ & Electronics',
    image: Aditya,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'A K Lekha',
    role: 'Intern',
    team: 'Team DAQ & Electronics',
    image: Lekha,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Rohan J S',
    role: 'Intern',
    team: 'Team DAQ & Electronics',
    image: Rohan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Manoji M R',
    role: 'Team Lead',
    team: 'Team Brakes',
    image: Manoji,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Keerthana Sri G',
    role: 'Design Engineer',
    team: 'Team Brakes',
    image: Keerthana,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'K Iyappan Muthukumar',
    role: 'Intern',
    team: 'Team Brakes',
    image: Mutukumar,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Harsha S',
    role: 'Intern',
    team: 'Team Brakes',
    image: Harsha,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'KeshavPrasad K',
    role: 'Intern',
    team: 'Team Brakes',
    image:  Kesavprasad,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Anurag Gupta',
    role: 'Team Lead',
    team: 'Team Steering',
    image: Anurag,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Sakshi Mishra',
    role: 'Design Engineer',
    team: 'Team Steering',
    image: Sakshi,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'J K Dhanush',
    role: 'Intern',
    team: 'Team Steering',
    image: JK,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Irfan S',
    role: 'Intern',
    team: 'Team Steering',
    image: Irfan,
    linkedin: 'www.google.com',
    year: 2023
  },
  { 
    name: 'Karmuhilan',
    role: 'Intern',
    team: 'Team Steering',
    image: Karim,
    linkedin: 'www.google.com',
    year: 2023
  }
];


export default teamMembers;
